import { css } from '@/styled-system/css';

export const specialOfferHeading = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.onHero.neutral',
});

export const specialOfferBody = css({
  fontSize: 'body-sm',
  color: 'text.onHero.neutral',
  paddingTop: 'tightest',
});
